var React = require('react');

function Essai (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.5 100h81V25c0-8.2-6.8-15-15-15h-66v90zM75 55.1H35M75 32.5H35","fill":"none","stroke":"#ffffff","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-545454","key":0}),React.createElement("path",{"d":"M55 77.7H35","fill":"none","stroke":"#ee693f","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-ee693f","key":1})]);
}

Essai.defaultProps = {"viewBox":"0 0 110 110","xmlSpace":"preserve","enableBackground":"new 0 0 110 110"};

module.exports = Essai;

Essai.default = Essai;
